module.exports = __webpack_public_path__ + "static/media/materialsBanner.01ef7169.jpg";